import { useLazyQuery, gql } from '@apollo/client'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Button from '@mui/material/Button'
import { memo, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { makeStyles } from 'tss-react/mui'

import { userSelector } from '../../../stores/app/selectors'

const useStyles = makeStyles()(() => ({
  root: {
    margin: '1em 0',
  },
}))

const EnableInsights = () => {
  const { classes } = useStyles()
  const user = useSelector(userSelector)
  const params = useParams()
  // TODO When going to typescript, just move the angle brackets to useLazyQuery.
  // const [runQuery, { data }] = useLazyQuery<Query, QueryGetFacebookAccountsArgs>(...)
  /** @type {import('@apollo/client').QueryTuple<import('@promoboxx/graphql-gateway-types').Query | undefined, import('@promoboxx/graphql-gateway-types').QueryGetFacebookAccountsArgs>} */
  const [runQuery, { data }] = useLazyQuery(gql`
    query EnableInsightsQuery($resourceType: String!, $resourceId: ID!) {
      getFacebookAccounts(
        resourceType: $resourceType
        resourceId: $resourceId
        params: { fields: [token_is_valid, manageable_pages] }
      ) {
        id
        permissions {
          read_insights
        }
      }
    }
  `)

  useEffect(() => {
    if (!user.id) {
      return
    }

    runQuery({
      variables: {
        resourceType: 'users',
        resourceId: user.id,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.id])

  if (!user) {
    return null
  }

  const userFacebookAccounts = (data || {}).getFacebookAccounts || []
  const hasInsightPermissions = userFacebookAccounts.some((facebookAccount) => {
    return (
      facebookAccount.permissions &&
      facebookAccount.permissions['read_insights']
    )
  })

  if (userFacebookAccounts.length === 0 || hasInsightPermissions) {
    return null
  }

  return (
    <Alert
      action={
        <Button
          color="inherit"
          href={`/#/${params.retailerAccountSlug}/${params.brandSlug}/settings?tab=social_accounts&addNewFacebookPage=1`}
          size="small"
        >
          Settings
        </Button>
      }
      classes={{
        root: classes.root,
      }}
      severity="info"
    >
      <AlertTitle>Please Enable Insights</AlertTitle>
      You must enable the Facebook Insights Permission to see Facebook Share
      Reporting on Promoboxx.
    </Alert>
  )
}

export default memo(EnableInsights)
